import { useState } from "react";
import { SettingsTabContainer } from "./timesheetSettingsStyles";
import {
  PageTitle,
  ContentHeader,
  Container,
  CommonGrid,
} from "../../../styledComponents/common";
import {
  TabButtonContainer,
  TabButton,
} from "../../../styledComponents/buttons";

import BackButtonComponent from "../../../components/BackButtonComponent/BackButtonComponent";

import ManualTimeSettings from "./ManualTimeSettings/manualTimeSettingsContainer";
import TimesheetApprovalSettings from "./TimesheetApprovalSettings/timesheetApprovalSettingsContainer";
import RoundTab from "components/RoundTabButtons/RoundTab";

const TimesheetSettings = (props) => {
  const [activeTab, setActiveTab] = useState("manual");

  const { history } = props;

  const handleTabSelect = (tabName) => {
    setActiveTab(tabName);
  };

  return (
    <div className="content">
      {/* <PageTitle>Timesheet Settings</PageTitle> */}
      <ContentHeader>
        <BackButtonComponent
          onClick={() => history.push("/user/settings")}
          subTitle="Back to settings"
        />
      </ContentHeader>

      <Container padding="0">
        <SettingsTabContainer>
          {/* <TabButtonContainer>
            <TabButton
              selected={activeTab}
              index="manual"
              onClick={() => handleTabSelect("manual")}
            >
              Manual Time
            </TabButton>
            <TabButton
              selected={activeTab}
              index="approval"
              onClick={() => handleTabSelect("approval")}
            >
              Timesheet Approval
            </TabButton>
          </TabButtonContainer> */}
          <CommonGrid gap="5px">
            <RoundTab
              text="Manual Time"
              selected={activeTab === "manual"}
              onClick={() => handleTabSelect("manual")}
            />
            <RoundTab
              text="Timesheet Approval"
              selected={activeTab === "approval"}
              onClick={() => handleTabSelect("approval")}
            />
          </CommonGrid>
        </SettingsTabContainer>
        {activeTab && activeTab === "approval" ? (
          <TimesheetApprovalSettings />
        ) : (
          <ManualTimeSettings />
        )}
      </Container>
    </div>
  );
};

export default TimesheetSettings;
